import { combineReducers } from 'redux';

import { reducer as httpRequestReducer } from '@travel/http-request';
import { reducer as i18nReducer } from '@travel/i18n';

import authCodeReducer from './authCode/reducer';
import commonErrorReducer from './commonError/reducer';
import hotelListReducer from './hotelList/reducer';
import hotelListMapReducer from './hotelListMap/reducer';
import planDetailsReducer from './planDetails/reducer';
import planListReducer from './planList/reducer';
import providerDetailsReducer from './providerDetails/reducer';
import searchAreasReducer from './searchAreas/reducer';
import serviceConditionsReducer from './serviceConditions/reducer';
import userAgentReducer from './userAgent/reducer';
import vacancyCalendarReducer from './vacancyCalendar/reducer';

import routerReducer from './__router/reducer';
import bannerReducer from './banner/reducer';
import commonReducer from './common/reducer';
import seoReducer from './seo/reducer';
import suggestionsReducer from './suggestions/reducer';
import searchEngineReducer from './searchEngine/reducer';

export default combineReducers({
  _i18n: i18nReducer,
  _httpRequest: httpRequestReducer,
  authCode: authCodeReducer,
  router: routerReducer,
  userAgent: userAgentReducer,
  commonError: commonErrorReducer,
  providerDetails: providerDetailsReducer,
  planList: planListReducer,
  planDetails: planDetailsReducer,
  suggestions: suggestionsReducer,
  searchAreas: searchAreasReducer,
  hotelList: hotelListReducer,
  hotelListMap: hotelListMapReducer,
  seo: seoReducer,
  vacancyCalendar: vacancyCalendarReducer,
  banner: bannerReducer,
  common: commonReducer,
  serviceConditions: serviceConditionsReducer,
  searchEngine: searchEngineReducer,
});
